import SeoFooter from 'app/shared/modules/SeoFooter';
import Footer from 'app/shared/modules/Footer';
import { pageFooterContainer, footerBreakout } from './pageFooter.styles';

export const PageFooter = () => (
  <div className={pageFooterContainer}>
    <SeoFooter hideDivider />
    <div className={footerBreakout}>
      <Footer noMarginTop />
    </div>
  </div>
);
